// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3KZd-","detailsBorder":"styles_detailsBorder__ei-jk"};